<template>
    <div class="overlay"
            v-if="hasOverlays"
            :class="rootClasses"
    >
        <div class="overlay--backdrop"
                @click="onBackgroundClick"/>

        <component
                class="overlay--content"
                :key="currentOverlay.id"
                :overlay-id="currentOverlay.id"
                :is="currentOverlay.component"
                v-bind="currentOverlay.args"/>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('overlay')],
        props: {},
        computed: {
            ...mapState('overlay', ['overlays']),
            ...mapGetters('overlay', ['currentOverlay']),

            hasOverlays() {
                return !!this.currentOverlay;
            },

            rootClasses() {
                if (!this.hasOverlays) {
                    return null;
                }

                return [
                    this.bemAdd(this.currentOverlay.component),
                ];
            },

        },

        methods: {
            ...mapActions('scroll', ['disableScroll']),
            ...mapActions('overlay', ['closeOverlay']),

            onBackgroundClick() {
                if (!this.currentOverlay) {
                    return;
                }

                if (this.currentOverlay.args.backgroundClosable === true) {
                    this.closeOverlay(this.currentOverlay);
                }
            },
        },
    };
</script>
